import React from 'react';

import { DomainObject, PrivateArchivalAid } from 'types';
import { ApiRoute, GridBodyType, PageKey, UrlRoute } from 'enums';
import { GridEntityConfig } from 'components/grid/grid-types';
import { Grid } from 'components/grid/grid';

//import { ArchivalUnitDetail } from './archival-aid-detail';

import { actionButtonsFactory } from 'components/grid/right-panel/action-buttons-factory';
import { ArchivalAidQuote } from '../archival-aid-quote';
import { ArchivalAidDetail } from '../archival-aid-detail';

import { ArchivalAidPrivateDownload } from './archival-aid-private-download';

export const archivalAidPrivateConfig: GridEntityConfig<
  DomainObject,
  PrivateArchivalAid
> = {
  id: 'soukrome-pomucky',
  title: 'Pomůcka (soukromá)',
  getLabel: (item) =>
    `Pomůcka (soukromá) - ${item.archivalAidMetadata.name} ${
      item.archivalAidMetadata.timeRange
        ? item.archivalAidMetadata.timeRange
        : ''
    }`,
  getId: (item) => item.id,
  urlRoute: UrlRoute.ARCHIVAL_AID_PRIVATE,
  apiRoute: ApiRoute.ARCHIVAL_AID_PRIVATE,
  listApi: '/api/archival-aid-metadata/list',
  pageKey: PageKey.DETAIL_ARCHIVAL_AID_PRIVATE,
  ActionButtons: actionButtonsFactory([
    {
      id: 'download',
      label: 'Stáhnout metadata/popis',
      Component: ArchivalAidPrivateDownload,
    },
    { id: 'quote', Component: ArchivalAidQuote },
  ]),
  icon: 'description',
  bodyComponents: {
    [GridBodyType.DETAIL]: (props) =>
      ArchivalAidDetail({ ...props, isPrivate: true, privateItem: props.item }),
  },
  params: {},
};

export const archivalAidPrivateGridConfig: any[] = [archivalAidPrivateConfig];

export const ArchivalAidPrivateGrid = () => (
  <Grid
    gridConfig={archivalAidPrivateGridConfig}
    leftPanelProps={{ hide: true }}
    centralPanelProps={{ hideTransitionButtons: true }}
  />
);
